import { TimeBucketSet } from '@fabric-ui/components/Table';
import { Field } from '../../types';

export const hasTimeBucket = (value: string) => TimeBucketSet.has(value);

export const filterTimeBucketFromDimensions = (dims: Field[]) => dims.filter(({ name }) => !hasTimeBucket(name));
